module.exports = __webpack_public_path__ + "static/media/zone.4af6ab71.svg";